import { render, staticRenderFns } from "./secondRefund.vue?vue&type=template&id=6c75a544&scoped=true"
import script from "./secondRefund.vue?vue&type=script&lang=js"
export * from "./secondRefund.vue?vue&type=script&lang=js"
import style0 from "./secondRefund.vue?vue&type=style&index=0&id=6c75a544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c75a544",
  null
  
)

export default component.exports